/**
 * ダッシュボード 受注
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/dashboard/drivers`

 const dashboard_driver_status = {

  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param search_type
     * @param target_date
     * @return {Promise<unknown>}
     */
    show ({ dispatch, commit, state }, { driver_id, target_date }) {
      const api_path = `${API_PATH}/${driver_id}/statuses`
      const params = {
        target_date: target_date,
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
 }
 export default dashboard_driver_status
